<template>
	<div
		ref="ticker"
		@dragstart.prevent
		@mousedown.prevent="onMouseDown"
		@mouseup.prevent
	>
		<svg
			class="-ml-2 h-2 w-[15px]"
			viewBox="0 0 14 8"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M7 8L13.0622 0.5H0.937822L7 8Z"
				fill="#2A8176"
			/>
		</svg>
		<div
			v-if="dragStarted"
			class="fixed z-20 -ml-px h-full border-r border-won-green"
		/>
	</div>
</template>

<script setup>
import { ref, onMounted, defineEmits, defineProps } from 'vue';
import { roundNearest } from '../../utils/helpers';

const emit = defineEmits(['moved']);
const props = defineProps({
	side: {
		type: String,
		required: true
	}
});

const dragStarted = ref(false);
const ticker = ref(null);

let shiftX = null;
let pdfRuler = null;
let newPosition = null;
const shiftMargin = 15;

onMounted(() => {
	pdfRuler = document.getElementById('pdf-ruler');
});

const onMouseDown = (e) => {
	dragStarted.value = true;
	shiftX = e.clientX - ticker.value.getBoundingClientRect().left;

	document.addEventListener('mousemove', onMouseMove);
	document.addEventListener('mouseup', onMouseUp);
};

// TODO: limit the movement of the ticker by 50% of the ruler
const onMouseMove = (e) => {
	if (! dragStarted.value) {return;}

	newPosition = roundNearest(e.clientX - shiftX - pdfRuler.getBoundingClientRect().left, 5);

	// if move on left outside of the ruler
	if (newPosition < shiftMargin) {
		newPosition = shiftMargin;
	} else if (newPosition > (pdfRuler.offsetWidth * .33) && props.side == 'left') {
		newPosition = pdfRuler.offsetWidth * .33;
	}

	// if move on right outside the ruler
	const rightEdge = pdfRuler.offsetWidth - shiftMargin;
	if (newPosition > rightEdge) {
		newPosition = rightEdge;
	} else if ( newPosition < (pdfRuler.offsetWidth * .66) && props.side == 'right' ) {
		newPosition = pdfRuler.offsetWidth * .66;
	}

	ticker.value.style.left = `${newPosition  }px`;
};

const onMouseUp = () => {
	document.removeEventListener('mouseup', onMouseUp);
	document.removeEventListener('mousemove', onMouseMove);
	dragStarted.value = false;
	if (newPosition === null) {return  false;}
	emit('moved', newPosition);
};

</script>
